import { render, staticRenderFns } from "./ModalCentered.vue?vue&type=template&id=3c6c66f7&"
import script from "./ModalCentered.vue?vue&type=script&lang=js&"
export * from "./ModalCentered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports